import React, { useState, useCallback, useEffect, useRef } from "react";
import { Button } from "primereact/button";
import MultiSearch from "../../../../Components/SearchInputs/MultiSearch/MultiSearch";
import { auditOptions, conditionOptions, fieldsOptions, propertyOptions } from "../../Objects/multiSelectObjects";
import { Dropdown } from "primereact/dropdown";
import { Whitelist } from "../../Interfaces/interfaces";
import AddNewWhitelistRuleDialog from "../Dialogs/addNewWhitelistRuleDialog";
import { MultiSelect } from "primereact/multiselect";
import { WhitelistRule } from "../../../../Interfaces/interfaces";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";

interface WhitelistFiltersProps {
    onFilterChange: (filters: any) => void;
    rows: Whitelist[];
    initialProperty?: string | string[];
    initialCondition?: string;
    initialValue?: string;
    initialAudit?: string;
    initialFields?: string | string[];
    onSearch?: (filters: any) => void;
    onReset?: (filters: any) => void;
}




const WhitelistFilters: React.FC<WhitelistFiltersProps> = ({
    onFilterChange,
    rows,
    initialProperty,
    initialCondition,
    initialValue,
    initialAudit,
    initialFields,
    onSearch,
    onReset,
}) => {
    const [selectedProperty, setSelectedProperty] = useState<string[]>([]);
    const [selectedCondition, setSelectedCondition] = useState<string>("");
    const [inputedValue, setInputedValue] = useState<string>("");
    const [selectedAudit, setSelectedAudit] = useState<string>("");
    const [selectedFields, setSelectedFields] = useState<string[]>([]);
    const [dialogVisible, setDialogVisible] = useState(false);
    const initialFiltersApplied = useRef(false);

    const handleSave = useCallback((updatedRule: WhitelistRule) => {


    }, []);
    const buildFiltersPayload = useCallback(
        () => ({
            selectedProperty,
            selectedCondition,
            inputedValue,
            selectedAudit,
            selectedFields,
        }),
        [
            selectedProperty,
            selectedCondition,
            inputedValue,
            selectedAudit,
            selectedFields,
        ]
    );

    const handleFilterChange = useCallback(() => {
        onFilterChange(buildFiltersPayload());
    }, [buildFiltersPayload, onFilterChange]);

    const handleAuditChange = (e: any) => {
        setSelectedAudit(e.value);
        setSelectedFields([]); 
    }

    const handleOpenDialog = () => {
        setDialogVisible(true); 
    };

    const resetFilters = () => {
        setSelectedProperty([]);
        setSelectedCondition("");
        setInputedValue("");
        setSelectedAudit("");
        setSelectedFields([]);
        const resetPayload = {
            selectedProperty: [],
            selectedCondition: "",
            inputedValue: "",
            selectedAudit: "",
            selectedFields: [],
        };
        if (onReset) {
            onReset(resetPayload);
            return;
        }
        handleFilterChange();
    };    

    useEffect(() => {
        if (initialFiltersApplied.current) return;
        const initialPropertyValues = initialProperty
            ? Array.isArray(initialProperty)
                ? initialProperty
                : [initialProperty]
            : [];
        const initialFieldValues = initialFields
            ? Array.isArray(initialFields)
                ? initialFields
                : [initialFields]
            : [];
        const hasInitialFilters =
            initialPropertyValues.length > 0 ||
            Boolean(initialCondition) ||
            Boolean(initialValue) ||
            Boolean(initialAudit) ||
            initialFieldValues.length > 0;

        if (!hasInitialFilters) return;

        if (initialPropertyValues.length > 0) {
            setSelectedProperty(initialPropertyValues);
        }
        if (initialCondition) {
            setSelectedCondition(initialCondition);
        }
        if (initialValue) {
            setInputedValue(initialValue);
        }
        if (initialAudit) {
            setSelectedAudit(initialAudit);
        }
        if (initialFieldValues.length > 0) {
            setSelectedFields(initialFieldValues);
        }

        initialFiltersApplied.current = true;
        setTimeout(() => {
            handleFilterChange();
        }, 0);
    }, [initialProperty, initialCondition, initialValue, initialAudit, initialFields, handleFilterChange]);

    return (
        <>
        <div
            className=" grid gap-3"
            style={{
                marginLeft: "0rem",
                marginTop: "-25px",
                marginBottom: "15px",
            }}
        >
            <div className="flex-column md:w-10rem gap-3">
                <div className="flex-1 flex-col">
                    <text style={{ color: "grey", fontSize: "small" }}>Property</text>
                    <Dropdown
                        value={selectedProperty}
                        options={propertyOptions}
                        onChange={(e) => setSelectedProperty(e.value)}
                        optionLabel="label"
                        style={{ width: "90%", borderRadius: "5px" }} />
                </div>
            </div>
            <div className="flex-column md:w-10rem gap-3">
                <div className="flex-1 flex-col">
                    <text style={{ color: "grey", fontSize: "small" }}>Condition</text>
                    <Dropdown
                        value={selectedCondition}
                        options={conditionOptions}
                        onChange={(e) => setSelectedCondition(e.value)}
                        optionLabel="label"
                        style={{ width: "90%", borderRadius: "5px" }} />
                </div>
            </div>
            {/* <div className="flex-column md:flex-col gap-3">
                <div className="flex-1 flex-col">
                <text style={{ color: "grey", fontSize: "small" }}>Values</text>

                    <InputText
                        value={inputedValue}
                        onChange={(e) => setInputedValue(e.target.value)}
                        style={{ width: "90%", borderRadius: "5px" }} />
                </div> */}
            {/* </div> */}
            <div className="flex-column md:w-10rem gap-3">
                <div className="flex-1 flex-col">
                    <text style={{ color: "grey", fontSize: "small" }}>Audit</text>
                    <Dropdown
                        value={selectedAudit}
                        options={auditOptions}
                        onChange={handleAuditChange}
                        optionLabel="label"
                        style={{ width: "90%", borderRadius: "5px" }}
                    />
                </div>
            </div>
            <div className="flex-column md:w-10rem gap-3">
                <div className="flex-1 flex-col">
                    <text style={{ color: "grey", fontSize: "small" }}>Fields</text>
                    <MultiSelect
                        value={selectedFields}
                        options={selectedAudit ? fieldsOptions[selectedAudit as any] : []} 
                        onChange={(e) => setSelectedFields(e.value)}
                        optionLabel="label"
                        style={{ width: "90%", borderRadius: "5px" }}
                        disabled={!selectedAudit}
                    />
                </div>
            </div>
                <div className="flex-column md:flex-col gap-3">
                <div className="flex-1 flex-col">
                    <text style={{ color: "grey", fontSize: "small" }}>
                        {" "}
                        Search{" "}
                    </text>
                    <div className="flex-1">
                        <Button
                            label="Search"
                            icon="pi pi-search"
                            onClick={() => {
                                if (onSearch) {
                                    onSearch(buildFiltersPayload());
                                    return;
                                }
                                handleFilterChange();
                            }} />
                    </div>
                </div>
            </div>
            <div className="flex-column md:flex-col gap-3">
                <div className="flex-1 flex-col">
                    <text style={{ color: "grey", fontSize: "small" }}>
                        {" "}
                        Reset Filters
                    </text>
                    <div className="flex-1">
                        <Button
                            label="Reset"
                            icon="pi pi-replay"
                            severity="danger"
                            onClick={resetFilters} />
                    </div>
                </div>
            </div>
            <div className="flex-column md:flex-col gap-3">
                <div className="flex-1 flex-col">
                    <text style={{ color: "grey", fontSize: "small" }}>
                        {" "}
                        New Rule
                    </text>
                    <div className="flex-1">
                    <Button label="Add Whitelist Rule" onClick={handleOpenDialog}/>

                    </div>
                </div>
            </div>


        </div>
      <AddNewWhitelistRuleDialog
                visible={dialogVisible}
                onHide={() => setDialogVisible(false)}
                onSave={handleSave} rowData={rows} />
            </>
    );
};

export default WhitelistFilters;
